import React from 'react'
import PropTypes from 'prop-types';
import {Image} from '@salesforce/retail-react-app/app/components/shared/ui';
import {Swiper, SwiperSlide} from 'swiper/react'
import {A11y} from 'swiper/modules'

const PhotoSlider = ({review, setSelectedReview}) => {
    const handlePhotoClick = (index) => {
        setSelectedReview({review, index});
    }
    return (
        <Swiper
            modules={[A11y]}
            a11y={{
                enabled: true
            }}
            spaceBetween={2}
            slidesPerView={'auto'}
            freeMode={true}>
            {review?.Photos.map((photo, index) => {
                return (
                    <SwiperSlide key={index} style={{width: '90px'}}>
                        <Image cursor={'pointer'}
                            onClick={() => handlePhotoClick(index)}
                            onKeyDown={(e) => e.key === 'Enter' && handlePhotoClick(index)?.(e)}
                            role="button"
                            _focusVisible={{
                                margin: '3px'
                            }}
                            tabIndex={0}
                            w="100%"
                            src={photo?.Sizes?.thumbnail?.Url}
                            alt="Review image"
                            aria-label="Open review" />
                    </SwiperSlide>
                );
            })}
        </Swiper>
    )
}

PhotoSlider.photos = {
    review: PropTypes.object.isRequired,
    setSelectedReview: PropTypes.func
};

export default PhotoSlider;
